import { splitDegrees, dateFormat, tryToBool, tryToFloat } from './functions'

export const onlineStatusCssClass = ((n: number) => {
    const classNames: string[] = [
        'unknow', 'offline', 'online'
    ]
    var name = 'online-status ' + classNames[n + 1]
    return name
})
export const videoOnlineFilter = ((n: number) => {
    const labs: string[] = [
        '未检测', '离线', '在线'
    ]
    return labs[n + 1]
})
export const caseStatusFilter = ((n: number) => {
    const labs: string[] = [
        '删除', '草稿', '提交'
    ]
    return labs[n]
})
export const caseWarningStatusFilter = ((n: number) => {
    const labs: string[] = [
        '', '一般', '较大', '严重', '特别严重'
    ]
    return labs[n]
})
export const exportLogStatusFilter = ((n: number) => {
    const labs: string[] = [
        '删除', 'Word生成中', '打包中', '打包完成', '已下载'
    ]
    return labs[n]
})
/*风险等级:1低 2中 3高*/
export const riskLevelFilter = ((n: number) => {
    const labs: string[] = [
        '/', '低', '中', '高'
    ]
    return labs[n]
})
export const unitStatusFilter = ((n: number) => {
    const labs: string[] = [
        '删除', '草稿', '退回', '待评审', '已评审'
    ]
    return labs[n]
})
export const deviceStatusFilter = ((n: number) => {
    const labs: string[] = [
        '删除', '正常', '发布', '停用'
    ]
    return labs[n]
})
//1草稿 2退回 3待受理 4办理中 5不通过 6通过
export const eighthUnitStatusFilter = ((n: number) => {
    let rs: string = ''
    switch (n) {
        case 1: rs = '草稿'; break;
        case 2: rs = '退回'; break;
        case 3: rs = '待受理'; break;
        case 4: rs = '办理中'; break;
        case 5: rs = '专家不通过'; break;
        case 6: rs = '专家通过'; break;
        case 7: rs = '省局遴选推荐'; break;
        case 8: rs = '推荐未通过'; break;
        case 9: rs = '核定公布'; break;
        default: rs = ''; break;
    }
    return rs
})
//第八批文保单位  0待委托 1待评审 2暂存 3已完成 4关闭
export const eighthUnitAssessmentStatusFilter = ((n: number) => {
    const labs: string[] = [
        '待委托', '待评审', '暂存', '已完成', '关闭'
    ]
    return labs[n]
})
/*巡查事件状态:0删除 1新建 2处理中 3整改未到位 4整改到位*/
export const eventStatusFilter = ((n: number) => {
    const labs: string[] = [
        '删除', '新建', '处理中', '整改未到位', '整改到位'
    ]
    return labs[n]
})
export const haveOrNot = ((n: any) => {
    let have: boolean = false
    if (typeof (n) == 'boolean') {
        have = n
    }
    if (typeof (n) == 'number') {
        have = n == 1
    }
    return have ? '有' : '无'
})
export const percentFilter = ((number: any) => {
    // var n = tryToFloat(number)
    // console.log(number, n)
    return (number * 100).toFixed(2) + "%"
})
export const yesNoFilter = ((n: any) => {
    let yes: boolean = false
    if (typeof (n) == 'boolean') {
        yes = n
    }
    if (typeof (n) == 'number') {
        yes = n == 1
    }
    return yes ? '是' : '否'
})
export const healthCodeColorTypeFilter = ((n: number) => {
    const labs: string[] = [
        '', '红码', '绿码', '黄码'
    ]
    return labs[n]
})
export const healthCodeAreaTypeFilter = ((n: number) => {
    const labs: string[] = [
        '', '市级', '区县', '乡镇街道'
    ]
    return labs[n]
})
export const planTypeFilter = ((type: number) => {
    return type == 1 ? '普通计划' : '重点计划'
})
export const planStatusFilter = ((n: number) => {
    const labs: string[] = [
        '删除', '启用', '关闭'
    ]
    return labs[n]
})
export const formatDate = ((d: string) => {
    if (d == '' || d == '0001-01-01T00:00:00') { return '' }
    const date = new Date(d)
    const format = window.baseConfig.DateFormat // 'yyyy-MM-dd'
    return dateFormat(date, format)
})
export const formatDateTime = ((d: string) => {
    if (d == '' || d == '0001-01-01T00:00:00') { return '' }
    const date = new Date(d)
    const format = window.baseConfig.DateTimeFormat // 'yyyy-MM-dd hh:mm:ss'
    return dateFormat(date, format)
})
export const formatDateTimess = ((d: string) => {
    if (d == '' || d == '0001-01-01T00:00:00') { return '' }
    const date = new Date(d)
    const format = window.baseConfig.DateTimessFormat // 'yyyy-MM-dd hh:mm:ss'
    return dateFormat(date, format)
})

//坐标转度分秒
export const formatPosition = (value: any) => {
    var obj = splitDegrees(value)
    return obj.fmt
    /*
    value = Math.abs(value)
    var v1 = Math.floor(value)//度  
    var v2 = Math.floor((value - v1) * 60)//分  
    var v3 = Math.round((value - v1) * 3600 % 60)//秒
    return v1 + '°' + v2 + '\'' + v3 + '"'
    */
}
export const formatMins = (minutes: number) => {
    var day = parseInt(Math.floor(minutes / 1440) + '')
    var hour = day > 0
        ? Math.floor((minutes - day * 1440) / 60)
        : Math.floor(minutes / 60)

    var minute = hour > 0
        ? Math.floor(minutes - day * 1440 - hour * 60)
        : minutes

    var time = ""
    if (day > 0) time += day + "天"
    if (hour > 0) time += hour + "小时"
    if (minute > 0) time += minute + "分钟"
    return time
}
